import { Dropdown, Space } from 'antd';
import { User, Settings, Logout } from '../Svg/Svg';
import { Link, useNavigate } from 'react-router-dom';
import { deleteTokens } from '../../utils/auth';
import { useDispatch } from 'react-redux';
import { signOut } from '../../redux/slices/authSlice';

export default function UserMenu() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const onLogOut = async () => {
        await dispatch(signOut()).unwrap();
        deleteTokens();
        navigate('/');
    };

    const dropdownActions = (e) => {
        const { key } = e;

        if (key === '2') {
            onLogOut();
        }
    };

    const menuItems = [
        {
            key: '1',
            label: (
                <>
                    <Link to="profile">Profile settings</Link>
                    <Settings />
                </>
            ),
        },
        {
            key: '2',
            label: (
                <>
                    <span>Sign out</span>
                    <Logout />
                </>
            ),
        },
    ];

    return (
        <div className="user-menu">
            <Space direction="vertical">
                <Dropdown
                    menu={{
                        items: menuItems,
                        onClick: (e) => dropdownActions(e),
                    }}
                    placement="bottomRight"
                    trigger={['click']}
                    overlayClassName="ant-dropdown-custom"
                >
                    <button className="user-menu__button">
                        <User />
                    </button>
                </Dropdown>
            </Space>
        </div>
    );
}
